
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goodtrust-life/about-us",
      function () {
        return require("private-next-pages/goodtrust-life/about-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goodtrust-life/about-us"])
      });
    }
  